export default __webpack_public_path__ + "static/media/img2.f5a2ab13.jpg";